import "./App.css";
import {
  Container,
  CssBaseline,
  Fab,
  Paper,
  ThemeProvider,
  Tooltip,
  createTheme,
} from "@mui/material";
import ViewInArIcon from "@mui/icons-material/ViewInAr";
import { useEffect, useState } from "react";
import Home from "./pages/Home";
import CV from "./pages/CV";
import { MenuItem } from "./components/MenuItem";
import DesktopNavBar from "./components/DesktopNavBar";
import MobileNavBar from "./components/MobileNavbar";
import { Route, Routes } from "react-router-dom";
import ParticleBackground from "./components/ParticleBackground";
import backgroundImage from "./assets/background.jpg";
import { useVisitorTracking } from "./hooks/useVisitorTracking";

function App() {
  useVisitorTracking();
  const [, setMenuValue] = useState("Home");
  const [screenSize, setScreenSize] = useState(getCurrentDimension());

  const theme = createTheme({
    palette: {
      mode: "dark",
      primary: { main: "#D5D8DD", dark: "#121417" },
      secondary: { main: "#1AAEFF" },
      background: { default: "#0f1115", paper: "#0f1115" },
    },
    typography: {
      fontFamily: '"Fira Code"',
      h1: { padding: "1rem 0", fontSize: "2rem" },
      h2: { padding: "1rem 0", fontSize: "1.5rem" },
      h3: { padding: "1rem 0", fontSize: "1.25rem" },
    },
  });

  const handleChangeValue = (newValue: string) => {
    setMenuValue(newValue);
  };

  function getCurrentDimension() {
    return { width: window.innerWidth, height: window.innerHeight };
  }

  function getIfPortraitMode() {
    return screenSize.height > screenSize.width;
  }

  useEffect(() => {
    const updateDimension = () => {
      setScreenSize(getCurrentDimension());
    };
    window.addEventListener("resize", updateDimension);
    return () => {
      window.removeEventListener("resize", updateDimension);
    };
  });

  const menuItems: Array<MenuItem> = [
    { Text: "Home", Path: "home" },
    { Text: "About", Path: "about" },
    { Text: "Experience", Path: "experience" },
    { Text: "Projects", Path: "projects" },
    { Text: "Lab", Path: "lab" },
    { Text: "Certificates", Path: "certificates" },
    { Text: "Contact", Path: "contact" },
  ];

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ParticleBackground />
      <Paper sx={{
        minHeight: "100vh",
        backgroundImage: `linear-gradient(rgba(15, 17, 21, 0.92), rgba(15, 17, 21, 0.92)), url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
      }} elevation={0}>
        <Container sx={{ "&.MuiContainer-root": { maxWidth: "1200px" }, position: "relative", zIndex: 1 }}>
          {getIfPortraitMode() ? (
            <MobileNavBar
              menuItems={menuItems}
            />
          ) : (
            <DesktopNavBar
              menuItems={menuItems}
            />
          )}
          <Routes>
            <Route
              path="/"
              element={<Home handleChangeValue={handleChangeValue} />}
            />
            <Route path="/cv" element={<CV />} />
          </Routes>
        </Container>
      </Paper>
      <Tooltip title="Explore my interactive 3D portfolio" placement="left">
        <Fab
          variant="extended"
          component="a"
          href="https://steller102-3d.vercel.app"
          target="_blank"
          sx={{
            position: "fixed",
            bottom: 24,
            right: 24,
            zIndex: 1000,
            backgroundColor: theme.palette.secondary.main,
            color: "#fff",
            "&:hover": {
              backgroundColor: "#0d8fd4",
            },
          }}
        >
          <ViewInArIcon sx={{ mr: 1 }} />
          3D Portfolio
        </Fab>
      </Tooltip>
    </ThemeProvider>
  );
}

export default App;
